import { render, staticRenderFns } from "./Blank.vue?vue&type=template&id=28342d82&"
import script from "./Blank.vue?vue&type=script&lang=js&"
export * from "./Blank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports